import { useCallback, useContext, useMemo } from 'react';
import { unpack_validation } from 'z3k-parser/validation/types';
import { AccountEditor } from 'shared/account.settings/model/types';
export function useAccountEditingProps(field) {
    const context = useContext(AccountEditor);
    const value = context.account[field];
    const onChange = useCallback((new_value) => context.setAccount((prevAccount) => ({ ...prevAccount, [field]: new_value })), [field]);
    const validation_result = unpack_validation(context.validation_result, field);
    return useMemo(() => ({
        value,
        onChange,
        validation_result,
        validation_warnings_result: null,
    }), [value, onChange, validation_result]);
}
export function useUiSettingsEditingProps(field) {
    const context = useContext(AccountEditor);
    const value = context.ui_settings[field];
    const onChange = useCallback((new_value) => context.setUiSettings((prev) => ({ ...prev, [field]: new_value })), [field]);
    const validation_result = unpack_validation(context.validation_result, field);
    return useMemo(() => ({
        value,
        onChange,
        validation_result,
        validation_warnings_result: null,
    }), [value, onChange, validation_result]);
}
